var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15.0136C8.9132 15.0136 6.00553 12.2057 6.00553 8.74213C6.00553 5.27852 8.9132 2.4707 12.5 2.4707C16.0868 2.4707 18.9944 5.27852 18.9944 8.74213C18.9944 12.2057 16.0868 15.0136 12.5 15.0136ZM12.5 15.0136L16.442 21.1053C16.8851 21.7903 17.9822 21.4428 17.9192 20.6375L17.7596 18.5983C17.711 17.9768 18.405 17.5581 18.9621 17.8727L20.7902 18.9051C21.512 19.3128 22.3164 18.513 21.8731 17.8282L18.0826 11.9486M12.5 15.0136L8.55805 21.1053C8.11486 21.7903 7.0179 21.4428 7.08089 20.6375L7.24037 18.5983C7.28897 17.9768 6.5951 17.5581 6.03797 17.8727L4.20988 18.9051C3.48794 19.3128 2.68367 18.513 3.12686 17.8282L6.91741 11.9486M14.6648 8.74213C14.6648 9.8967 13.6956 10.8326 12.5 10.8326C11.3044 10.8326 10.3352 9.8967 10.3352 8.74213C10.3352 7.58759 11.3044 6.65166 12.5 6.65166C13.6956 6.65166 14.6648 7.58759 14.6648 8.74213Z",
    stroke: "#5D697C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAward);
export default __webpack_public_path__ + "static/media/award.b2de2d21b4dac1f5789f90062787db80.svg";
export { ForwardRef as ReactComponent };